var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7439_21737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 3.33301H13.333L16.6663 6.66634V14.9997C16.6663 15.4417 16.4907 15.8656 16.1782 16.1782C15.8656 16.4907 15.4417 16.6663 14.9997 16.6663H4.99967C4.55765 16.6663 4.13372 16.4907 3.82116 16.1782C3.5086 15.8656 3.33301 15.4417 3.33301 14.9997V4.99967C3.33301 4.55765 3.5086 4.13372 3.82116 3.82116C4.13372 3.5086 4.55765 3.33301 4.99967 3.33301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 11.6667C8.33301 12.1087 8.5086 12.5326 8.82116 12.8452C9.13372 13.1577 9.55765 13.3333 9.99967 13.3333C10.4417 13.3333 10.8656 13.1577 11.1782 12.8452C11.4907 12.5326 11.6663 12.1087 11.6663 11.6667C11.6663 11.2246 11.4907 10.8007 11.1782 10.4882C10.8656 10.1756 10.4417 10 9.99967 10C9.55765 10 9.13372 10.1756 8.82116 10.4882C8.5086 10.8007 8.33301 11.2246 8.33301 11.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 3.33301V6.66634H6.66699V3.33301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7439_21737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.3bb5400a586d99654fc57cab4b17f23e.svg";
export { ForwardRef as ReactComponent };